module.exports = __webpack_public_path__ + "static/images/components/Nation/images/flag-all.64fe0d30.png";


//////////////////
// WEBPACK FOOTER
// ./components/Nation/images/flag-all.png
// module id = 2623
// module chunks = 11